<template lang="pug">
  .container
    .is-charts
      h2.title(v-if="title") {{ title }}
      highcharts.chart(:options="chartOptions")
      slot
</template>

<script>
export default {
  name: 'VChart',
  props: {
    title: {
      type: String
    },
    type: {
      type: String,
      default: function () {
        return 'column'
      }
    },
    polar: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    legend: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    xAxis: {
      type: Array,
      default: function () {
        return []
      }
    },
    series: {
      type: Array,
      default: function () {
        return [
          {
            data: [10, 0, 8, 2, 6, 4, 5, 5],
            color: '#6fcd98'
          }
        ]
      }
    }
  },
  data () {
    return {
      chartOptions: {
        chart: {
          polar: this.polar,
          type: this.type
        },
        title: {
          text: ''
        },
        legend: {
          enabled: this.legend,
          useHTML: true
        },
        tooltip: {
          enabled: this.legend,
          useHTML: true
          // headerFormat: '<b>{point.x}</b><br/>',
          // pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              color: 'white'
            }
          }
        },
        xAxis: {
          categories: this.xAxis,
          tickmarkPlacement: 'on',
          lineWidth: 0,
          labels: {
            useHTML: true
          }
        },
        yAxis: [
          {
            gridLineInterpolation: 'polygon',
            min: 0,
            max: this.type === 'column' ? 100 : (this.polar ? 1 : undefined),
            title: {
              text: ''
            }
          },
          {
            title: {
              text: ''
            },
            gridLineWidth: 0,
            opposite: true
          }
        ],
        series: this.series,
        credits: {
          enabled: false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.is-charts {
  text-align: left;
  position: relative;
  margin: 4em 0;
  padding: 2em;
  min-height: 20vh; // dev
  h2 {
    color: lighten($mainBlu, 10%);
    font-size: 1.7em;
    font-weight: 300;
    text-transform: uppercase;
    position: relative;
    padding-left: 16px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      width: 6px;
      height: 29px;
      background-color: lighten($mainBlu, 20%);;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VChart.vue